// Static filter option lists for the events UI (relocated from mockData.js —
// Phase 10F). These are presentation taxonomies, NOT event data.

export const cities = ['New York', 'New Jersey', 'Philadelphia', 'Newark', 'Jersey City', 'Brooklyn'];

export const categories = [
  { id: 'all', name: 'All Events' },
  { id: 'trending', name: 'Trending' },
  { id: 'bollywood', name: 'Bollywood' },
  { id: 'punjabi', name: 'Punjabi' },
  { id: 'edm', name: 'EDM' },
  { id: 'special', name: 'Special Events' },
];
